"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModalBenefit = void 0;
var react_1 = __importDefault(require("react"));
var ModalBenefit_module_scss_1 = __importDefault(require("./ModalBenefit.module.scss"));
var modalSlice_1 = require("../../redux/slice/modalSlice");
var Svg_1 = require("../svg/Svg");
var react_router_dom_1 = require("react-router-dom");
var selectors_1 = require("../../redux/selectors");
var react_redux_1 = require("react-redux");
var ModalBenefit = function () {
    var dispatch = (0, react_redux_1.useDispatch)();
    var modalBenefitState = (0, react_redux_1.useSelector)(selectors_1.modalSelector).promotion.modalState;
    var title = (0, react_redux_1.useSelector)(selectors_1.modalSelector).promotion.title;
    var description = (0, react_redux_1.useSelector)(selectors_1.modalSelector).promotion.description;
    var link = (0, react_redux_1.useSelector)(selectors_1.modalSelector).promotion.link || '';
    var stopPropagationHandler = function (event) { return event.stopPropagation(); };
    var closeModalHandler = function () {
        dispatch((0, modalSlice_1.closeModal)('promotion'));
    };
    return (react_1.default.createElement("div", { className: "".concat(ModalBenefit_module_scss_1.default.modal_benefit, " ").concat(modalBenefitState ? ModalBenefit_module_scss_1.default.modal_benefit_active : ''), onClick: closeModalHandler },
        react_1.default.createElement("div", { className: ModalBenefit_module_scss_1.default.modal_benefit__inner, onClick: stopPropagationHandler },
            react_1.default.createElement(Svg_1.Cross, { handler: closeModalHandler, className: "" }),
            react_1.default.createElement("h3", { className: ModalBenefit_module_scss_1.default.modal_benefit__title }, title),
            react_1.default.createElement("p", { className: ModalBenefit_module_scss_1.default.modal_benefit__description }, description),
            link ? (react_1.default.createElement(react_router_dom_1.Link, { className: ModalBenefit_module_scss_1.default.modal_benefit__btn, to: link, onClick: closeModalHandler }, "\u041F\u043E\u0434\u0440\u043E\u0431\u043D\u0435\u0435")) : null)));
};
exports.ModalBenefit = ModalBenefit;
